//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class OnlineResourceFolderInputItem extends ItemBase {
    Description: string | null = null;
    Filename: string | null = null;
    UploadedByTeacherID: string | null = null;
    SpaceID: string | null = null;
    ContainingFolderID: string | null = null;
    VintageFilenameIfDuplicate: boolean = false;

    constructor(initializer?: Partial<OnlineResourceFolderInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OnlineResourceFolderInputItem";
}
